<template>
  <div style="position:fixed;top:0;left:0;right:0;bottom:50px;overflow:hidden;display:flex;align-items:center;justify-content:center;">
    <button @click="openKefu" style="padding:12px 24px;font-size:16px;background:#007aff;color:#fff;border:none;border-radius:8px;cursor:pointer;">
      点击进入在线客服
    </button>
  </div>
</template>
<script>
export default {
  name: 'kefu',
  data() {
    return { url: null };
  },
  created() {
    this.getservicerurl();
  },
  methods: {
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code == 200) { that.url = res.data.url; }
      });
    },
    openKefu() {
      if (this.url) {
        window.open(this.url, '_blank');
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue